// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__O3Dis","validationTips":"StatementDescriptor_validationTips__1Bu0i"};